import { IconCircleCheckFilled } from "@tabler/icons-react";

export default function Addon({ data, onAddonSelect }) {
    const discountPercentage = () => {
        return Math.round(((data.originalPrice - data.originalOfferPrice) / data.originalPrice) * 100, 2)
    };

    return (
        <div className="fotoowl-plan col-md-6 col-xl-3">
            <div className={"main-card h-100 position-relative card"}>
                <div className="px-1 card-header">
                    <div className="d-flex justify-content-start">
                        <img src="/images/card-advance-sale.png" height="60px" />
                        <div className="d-flex flex-column justify-content-center align-items-start pt-1 mx-2">
                            <strong className="text-uppercase">{data.name}</strong>
                            {!data.isCustom && (
                                <div className="mb-0">
                                    <div>
                                        <div className="d-flex">
                                            <div className="before-discount-price">₹ {data.originalPrice}</div>
                                            <span className="text-success ms-2"><small>{discountPercentage()}% off</small></span>
                                        </div>
                                        <div className="d-flex align-items-end  flex-wrap">
                                            <h3 className="mb-0">₹ {data.originalOfferPrice}</h3>
                                        </div>
                                    </div>
                                    <span>Validity: {data.validityKind == "TillPackage" ? "Till Current Package" : data.validity + " " + data.validityKind}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="px-1 px-md-3 card-body">
                    <div>
                        <h4>
                            <strong>
                                {data.allowableEventCount == 1
                                    ? data.allowableEventCount + " Invitation"
                                    : data.allowableEventCount > 1
                                        ? data.allowableEventCount + " Invitations"
                                        : ""
                                }
                            </strong>
                            <strong>
                                {data.allowableDemoCount == 1
                                    ? data.allowableDemoCount + " Demo"
                                    : data.allowableDemoCount > 1
                                        ? data.allowableDemoCount + " Demos"
                                        : ""
                                }
                            </strong>

                            <strong>
                                {data.allowableDemoCount == 0 && data.allowableEventCount == 0 && data.allowableImageCount > 0
                                    ? data.allowableImageCount + " Images"
                                    : ""
                                }
                            </strong>

                            <strong>
                                {data.allowableDemoCount == 0 && data.allowableEventCount == 0 && data.allowableVideoCount > 0
                                    ? data.allowableVideoCount + " Videos"
                                    : ""
                                }
                            </strong>

                        </h4>
                    </div>
                    <div className="d-flex flex-column align-items-start gap-2 ">
                        {data.allowableImageCount > 0 && (data.allowableDemoCount > 0 || data.allowableEventCount > 0)
                            ? <div style={{ fontSize: "0.85rem" }}>
                                <IconCircleCheckFilled className="me-1 text-primary align-middle" size={17} />
                                {data.allowableImageCount} Images
                            </div> :
                            <div />}
                        {data.allowableVideoCount > 0 && (data.allowableDemoCount > 0 || data.allowableEventCount > 0)
                            ? <div style={{ fontSize: "0.85rem" }}>
                                <IconCircleCheckFilled className="me-1 text-primary align-middle" size={17} />
                                {data.allowableVideoCount} Videos
                            </div> :
                            <div />}
                    </div>
                </div>
                <div className="card-footer">
                    <div className="d-flex gap-2 flex-column">
                        <button className="btn btn-primary w-100" onClick={(e) => onAddonSelect(data)}>Select</button>
                    </div>
                </div>
            </div>
        </div >
    );
}